<template>
  <div
    class="kd-layers"
    :class="{
      'kd-layers--dimmed': LAYOUT_MODE_ACTIVE,
    }"
  >
    <kd-layer
      v-for="layer in ACTIVE_SIDE.layers"
      :key="layer.id"
      :layer="layer"
      class="kd-card__layer">
    ></kd-layer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import KdLayer from '@/components/KdLayer';

import {
  ACTIVE_SIDE,
  LAYOUT_MODE_ACTIVE,
} from '@/store/getter-types';

export default {
  computed: {
    ...mapGetters([
      ACTIVE_SIDE,
      LAYOUT_MODE_ACTIVE,
    ]),
  },
  components: {
    KdLayer,
  },
}
</script>

<style lang="scss">
.kd-layers {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
